import { Pipe, PipeTransform } from '@angular/core';
import { SecondsPrefix } from '@core/enums';

@Pipe({
  name: 'scConvertSecondsTo',
  standalone: true,
})
export class ConvertSecondsToPipe implements PipeTransform {
  transform(
    seconds: string | number,
    prefix: SecondsPrefix = SecondsPrefix.SECOND
  ): string {
    const secondsNumber =
      typeof seconds === 'string' ? parseInt(seconds, 10) : seconds;
    if (isNaN(secondsNumber)) {
      return seconds.toString();
    }

    switch (prefix) {
      case SecondsPrefix.MINUTE:
        return `${Math.floor(secondsNumber / 60)}:${('0' + (secondsNumber % 60)).slice(-2)} min`;
      case SecondsPrefix.HOUR:
        return `${Math.floor(secondsNumber / 3600)}:${('0' + (secondsNumber % 3600) / 60).slice(-2)} h`;
      default:
        return `${secondsNumber} s`;
    }
  }
}
